import { render } from "./HelloWorld.vue?vue&type=template&id=de4316aa&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=de4316aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de4316aa"

export default script